var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box content"},[_c('graph',{attrs:{"campusID":_vm.campus.campusID,"cohort":_vm.campus.currentCohort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }